import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { NavigatorContainerStyled } from './mapStyles';
import 'leaflet-polylinedecorator';
import { useIonViewDidEnter } from '@ionic/react';
import { AONB_Bounds } from '../../application/config';
import LocationMarker from '../Mapping/LocationMarker';
import { Trail } from '../../models/Trail';
import SingleTrailNavigatorController from '../Mapping/SingleTrailNavigatorController';
import SingleTrailNavigatorMarker from '../Mapping/SingleTrailNavigatorMarker';

type MapProps = {
	trail: Trail;
};

function SingleTrailNavigator({ trail }: MapProps): ReactElement {
	useIonViewDidEnter(() => {
		window.dispatchEvent(new Event('resize'));
	});
	return (
		<>
			<NavigatorContainerStyled
				id="navigatorMap"
				className="fullMap"
				center={AONB_Bounds.getCenter()}
				zoom={14}
				dragging={false}
				zoomControl={false}
				doubleClickZoom={false}
				scrollWheelZoom={false}>
				<>
					<SingleTrailNavigatorController trail={trail} />
					<TileLayer
						attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					<LocationMarker />
					<SingleTrailNavigatorMarker
						key={`place-trails`}
						trail={trail}
					/>
				</>
			</NavigatorContainerStyled>
		</>
	);
}

export default SingleTrailNavigator;
